import experiments from 'src/redux/reducers/experiments';
import form from 'src/redux/reducers/form';
import inputs from 'src/redux/reducers/inputs';
import hiddenRecommendations from 'src/redux/reducers/hidden-recommendations';
import quickEdit from 'src/redux/reducers/quick-edit';
import queryParams from 'src/redux/reducers/query-params';
import recommendations from 'src/redux/reducers/recommendations';
import userData from 'src/redux/reducers/user-data';
import marketplaceOffers from './marketplaceOffers';

const reducers = {
  experiments,
  form,
  hiddenRecommendations,
  inputs,
  quickEdit,
  queryParams,
  recommendations,
  userData,
  marketplaceOffers,
};

export default reducers;
